import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot, RouterStateSnapshot,
  UrlTree, CanActivate, Router
} from '@angular/router';
import { Observable, of } from 'rxjs';
import { AuthenticationService } from '../services/authentication/authentication.service';
import { FindValueSubscriber } from 'rxjs/internal/operators/find';
import { catchError, map } from 'rxjs/operators';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AuthenticationGuard implements CanActivate {
  is_valid;

  constructor(
    public authentication_service: AuthenticationService,
    public router: Router,
  ) { }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {

    return this.authentication_service.validate_authentication().pipe(
      map((e) => {
        // console.log(e)
        // if (!environment.production) return true;
        if (e) {
          this.authentication_service.start_validation_interval();
          return true;
        } else {
          this.router.navigate(['/application/authentication']);
          return false;
        }
      }),
      catchError((err) => {
        if (!environment.production) return of(true);
        this.router.navigate(['/application/authentication']);
        return of(false);
      }),
    );
    }
  }
